// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__K15R9","options":"AnswerScale_options__2QGAi","selected":"AnswerScale_selected__3R0Gf"};